(function($){

	// simulate a "window.location.search" string.
	var homeurl = "?slick0=3", initialSlide = 0;

	$(".slider-single .et_pb_slides").each(function(k, v){

	    var search = window.location.search || homeurl,
	        queries = search.slice(1).split("&"),
	        checkQuery;

	    for(var query in queries ) {
	        checkQuery = queries[query].split("=");
	        if( checkQuery[0] === "slick"+k ) {
	            initialSlide = parseInt(checkQuery[1],10);
	        }
	    }

		// If no initial slide set from querystring, check for cookies
		if (initialSlide == 3 && sessionStorage.getItem('nca-homepage-slide') !== null) {
			let cookie = parseInt(sessionStorage.getItem('nca-homepage-slide'));

			if (cookie >= 0 && cookie < 3) {
				initialSlide = cookie;
			}
		}

	    console.log(initialSlide);

		$('.slider-single .et_pb_slides').slick({
			initialSlide: initialSlide,
			asNavFor: '.slider-nav .et_pb_slides',
			draggable: false,
		});



		$('.slider-nav .et_pb_slides').slick({
			asNavFor: '.slider-single .et_pb_slides',
			centerMode: true,
			slidesToShow: 3,
			slidesToScroll: 0,
			focusOnSelect: true,
			infinite: true,
			centerPadding: '0px'
		});
	});

	//Set cookie
	if ($('#homepage-slider-nav').length) {
		$('#homepage-slider-nav .et_pb_slide').click(function(e) {
			let index = parseInt($(this).attr('data-slick-index'));

			sessionStorage.setItem('nca-homepage-slide', index);

			// Scroll to the top of the page
			window.scrollTo(0, 0);
		});
	}

 	$('.slider-nav .et_pb_slides .slick-slide').removeClass('slick-current');

 	//Set active
	if (initialSlide < 3) {
		$('.slider-nav .et_pb_slides .slick-slide').each(function(item) {
			if ($(this).attr('data-slick-index') == initialSlide) {
				$(this).addClass('slick-current');
			}
		});
	}

	//set active class to first thumbnail slides
	$('.slider-nav .et_pb_slides .slick-slide').eq(0).addClass('slick-active');

	// On before slide change match active thumbnail to current slide
	$('.slider-single .et_pb_slides').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
	 	var mySlideNumber = nextSlide;
	 	$('.slider-nav .et_pb_slides .slick-slide').removeClass('slick-current');
	 	$('.slider-nav .et_pb_slides .slick-slide').eq(mySlideNumber).addClass('slick-current');
	});


	$('.slide-hub').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 1000,
		arrows: true,
		dots: false,
		pauseOnHover: false,
		infinite: false,
		responsive: [{
			breakpoint: 1100,
			settings: {
				slidesToShow: 2
			}
		},{
			breakpoint: 768,
			settings: {
				slidesToShow: 2
			}
		}, {
			breakpoint: 520,
			settings: {
				slidesToShow: 1
			}
		}]
	});

})(jQuery);
